import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

export const getRequestActAvailable = async () => {
  const res = await request.get(
    '/Request/act/awailable',
    {},
    'Не удалось получить доступные акты'
  );

  return res;
};

const useRequestActAvailable = (options) =>
  useQuery(queryKeys.requestActAvailable(), getRequestActAvailable, options);

export default useRequestActAvailable;
